import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'

export const getReports = get('reports')

export const getReportsList = pipe(getReports, get('list'))

export const getGlobalFiles = get('globalFiles')
